import DataMixin from "@/assets/plugins/mps-common/data/DataMixin";

export default {

    install(Vue) {
        Vue.mixin(DataMixin);
    },

}
